import { requestCMSPageConfigFromRoute } from '@cms/service'
import logger from '@logger'

export async function getArticle(store, route) {
  try {
    const { payload: article } = await store.dispatch(
      'http/request',
      requestCMSPageConfigFromRoute({ route }),
    )

    return article
  } catch (err) {
    logger.error('Error fetching page config from Contentful', {
      error: err,
    })

    throw err
  }
}
